import * as CONSTANTS from "../constants/actions/api";

/**
 * @name INITIAL_STATE
 * @constant
 * @description
 * @type {Object}
 * @default
 */
const INITIAL_STATE = {
  // false -> means no api calls is pending, true -> means api call is pending
  api_state: false,
  api_data: null,
  api_error: null,
};

/**
 * **DO NOT** Manipulate the state directly, always apply to a new object first!! If you don't redux will not
 * recognize a change in the data and the components will not receive the correct information.
 *
 * @name reducer
 * @function
 * @description Handles reduction of data accross components for the piece of the site implied by the filename
 * @param {Object} state Current state of the data
 * @param {Object} action Information passed from the corresponding actions file
 */
const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CONSTANTS.LOADING:
      return {
        ...state,
        api_state: true,
      };
    case CONSTANTS.SUCCESS:
      return {
        ...state,
        api_state: false,
        api_data: action.payload,
        api_error: null,
      };
    case CONSTANTS.ERROR:
      return {
        ...state,
        api_state: false,
        api_error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
